import api from '../axios.config';
import { API_ENDPOINTS } from './endpoints';

/**
 * My Applications — protected, bearer-auth listing of the candidate's own
 * outreach ("interest requests") and interview records. Read-only: the
 * actions themselves (acknowledge / accept / decline) happen on the
 * magic-link pages (SeniorLevelFlow, InterviewInvite), not here.
 */
export const MyPipelineService = {
  getInterestRequests: async ({ page = 1, pageSize = 10 } = {}) => {
    const response = await api.get(
      API_ENDPOINTS.MY_PIPELINES.INTEREST_REQUESTS,
      { params: { page, pageSize } }
    );
    return response?.data ?? { items: [], pagination: null };
  },

  getInterviews: async ({ page = 1, pageSize = 10 } = {}) => {
    const response = await api.get(API_ENDPOINTS.MY_PIPELINES.INTERVIEWS, {
      params: { page, pageSize },
    });
    return response?.data ?? { items: [], pagination: null };
  },
};

export default MyPipelineService;
